import { engineComponent } from "neo-common";
import { Style } from "./Style";
import { ComponentTypes } from "../../ComponentTypes";

/**
 * ContainerStyle only holds xml node for container elements.
 * Example:
 *   <ContainerStyle Class="ContainerStyle">
 *       <Child1 />
 *       <Child2 />
 *       ...
 *       <ChildX />
 *   </ContainerStyle>
 * @class ContainerStyle
 * @extends Style
 */
@engineComponent(ComponentTypes.Style)
export class ContainerStyle extends Style {
    node: Element;

    constructor() {
        super();
    }

    /**
     * Get attributes from xml and set up supported properties.
     * @method create
     * @param node is Element from xml
     * @return void
     */
    create(node: Element): void {
        super.create(node);

        // store node for container elements
        this.node = node;
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Components/Elements/Styles/ContainerStyle.ts
 **/